import styled from 'styled-components';

const StyledContainerContent = styled.div`
	position: relative;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	row-gap: 20px;
`;

export { StyledContainerContent };
